module.exports = __webpack_public_path__ + "static/media/fileUpload.d0bbc39e.svg";